import { useState } from 'react'
import Link from 'next/link'
import s from './DesktopNav.module.css'
import dynamic from 'next/dynamic'
import { LocationMarker, Phone } from '@components/yadav/icons'

const Searchbar = dynamic(() => import('@components/common/Searchbar'))
const UserNav = dynamic(() => import('@components/common/UserNav'))
const Logo = dynamic(() => import('@components/ui/Logo'))
const DropdownMenu = dynamic(() => import('./DropdownMenu'))

const DesktopNav = () => {
  const [phoneActive, setPhoneActive] = useState(false)
  const [locationActive, setLocationActive] = useState(false)

  return (
    <div>
      <nav className="md:pt-11 md:pb-[56px] md:flex flex-row items justify-between content-center h-fit px-6">
        <ul className={s.navList}>
          <li className="flex flex-row flex-1">
            <Searchbar className="" />
          </li>
          <li className="flex flex-row">
            <Link href="/jewelry-store-san-francisco">
              <a
                aria-label="Yadav location"
                className={s.icon}
                onMouseEnter={() => setLocationActive(true)}
                onMouseLeave={() => setLocationActive(false)}
              >
                <LocationMarker locationActive={locationActive} />
              </a>
            </Link>
            <Link href="/jewelry-store-san-francisco">
              <a>
                <span
                  className="hidden lg:inline ml-2 text-xs text-gray-dark mr-6"
                  onMouseEnter={() => setLocationActive(true)}
                  onMouseLeave={() => setLocationActive(false)}
                >
                  Visit us In SF
                </span>
              </a>
            </Link>
            <a
              aria-label="Click to call Yadav"
              href="tel:8889688810"
              className={s.phoneIcon}
              onMouseEnter={() => setPhoneActive(true)}
              onMouseLeave={() => setPhoneActive(false)}
            >
              <Phone phoneActive={phoneActive} />
            </a>
            <a aria-label="Yadav phone number" href="tel:8889688810">
              <span
                className="hidden lg:inline ml-2 text-xs uppercase text-gray-dark tracking-wider"
                onMouseEnter={() => setPhoneActive(true)}
                onMouseLeave={() => setPhoneActive(false)}
              >
                888-968-8810
              </span>
            </a>
          </li>
        </ul>
        <div className="absolute left-1/2 -translate-x-1/2 mb-7 -mt-[15px] md:-mt-[22px]">
          <Link href="/">
            <a aria-label="Click to go back to homepage">
              <Logo />
            </a>
          </Link>
        </div>
        <div className="flex flex-row flex-1 justify-end">
          <UserNav />
        </div>
      </nav>
      <nav>
        <DropdownMenu />
      </nav>
    </div>
  )
}

export default DesktopNav
